import produce from 'immer';
import { createSelector } from 'reselect';
// @ts-expect-error: `retrack` library has non type
import { getSelector, namespaceReducerActions } from 'retrack';

export interface Store {
    initializationStatus: string;
    language: string;
    namespace: string;
}

const INITIALIZATION_STATUS = {
    UNKNOWN: 'UNKNOWN',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
};

export const DUCK_NAME = 'i18n';

const initialState: Store = {
    initializationStatus: INITIALIZATION_STATUS.UNKNOWN,
    language: '',
    namespace: '',
};

export const duckActions = {
    INITIALIZE: 'INITIALIZE',
    SET_INITIALIZATION_STATUS: 'SET_INITIALIZATION_STATUS',
    ASK_SPACE_FOR_LANGUAGE_NAMESPACE: 'ASK_SPACE_FOR_LANGUAGE_NAMESPACE',
    ASK_SPACE_FOR_LANGUAGE_NAMESPACE_SUCCEEDED: 'ASK_SPACE_FOR_LANGUAGE_NAMESPACE_SUCCEEDED',
    SET_LANGUAGE: 'SET_LANGUAGE',
    SET_NAMESPACE: 'SET_NAMESPACE',
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    CHANGE_NAMESPACE: 'CHANGE_NAMESPACE',
};

const reducer = produce((draft: Store, action) => {
    switch (action.type) {
        case duckActions.SET_INITIALIZATION_STATUS:
            draft.initializationStatus = action.payload.status;
            break;
        case duckActions.SET_LANGUAGE:
            draft.language = action.payload.language;
            break;
        case duckActions.SET_NAMESPACE:
            draft.namespace = action.payload.namespace;
            break;
        // no default
    }
}, initialState);
namespaceReducerActions(reducer, duckActions);

export default reducer;

export const duckActionCreators = {
    initialize: function initialize(userLanguage: string) {
        return { type: duckActions.INITIALIZE, payload: { userLanguage } };
    },
    initializationSucceeded: function initializationSucceeded() {
        return {
            type: duckActions.SET_INITIALIZATION_STATUS,
            payload: { status: INITIALIZATION_STATUS.SUCCEEDED },
        };
    },
    initializationFailed: function initializationFailed() {
        return {
            type: duckActions.SET_INITIALIZATION_STATUS,
            payload: { status: INITIALIZATION_STATUS.FAILED },
        };
    },
    askSpaceForLanguageNamespace: function askSpaceForLanguageNamespace() {
        return {
            type: duckActions.ASK_SPACE_FOR_LANGUAGE_NAMESPACE,
        };
    },
    askSpaceForLanguageNamespaceSucceeded: function askSpaceForLanguageNamespace(namespace: string) {
        return {
            type: duckActions.ASK_SPACE_FOR_LANGUAGE_NAMESPACE_SUCCEEDED,
            payload: { namespace },
        };
    },
    setLanguage: function setLanguage(language: string | null) {
        return {
            type: duckActions.SET_LANGUAGE,
            payload: { language },
        };
    },
    setNamespace: function setNamespace(namespace: string) {
        return {
            type: duckActions.SET_NAMESPACE,
            payload: { namespace },
        };
    },
    changeLanguage: function changeLanguage(languageCode: string) {
        return {
            type: duckActions.CHANGE_LANGUAGE,
            payload: {
                languageCode,
            },
        };
    },
    changeNamespace: function changeNamespace(namespace: string) {
        return {
            type: duckActions.CHANGE_NAMESPACE,
            payload: {
                namespace,
            },
        };
    },
};

const i18nSelector = getSelector(reducer) as (state: Store) => Store;

const languageSelector = createSelector(i18nSelector, (i18nState: Store) => i18nState.language);

const namespaceSelector = createSelector(i18nSelector, (i18nState: Store) => i18nState.namespace);

export const duckSelectors = {
    i18nSelector,
    languageSelector,
    namespaceSelector,
};
